export const getFinalPrice = (discountedPrice?: number, price?: number) => {
  return discountedPrice || price || null;
};
